import { FC, KeyboardEvent } from 'react'

import { cn } from '@/lib/utils'

export interface UnitePathOptionCardProps {
  selected: boolean
  onSelect: () => void
  title: string
  featureTitle: string
  featureSub: string
  priceLine: string
}

export const UnitePathOptionCard: FC<UnitePathOptionCardProps> = ({ selected, onSelect, title, featureTitle, featureSub, priceLine }) => {
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onSelect()
    }
  }

  return (
    <div
      role='button'
      tabIndex={0}
      aria-pressed={selected}
      onClick={onSelect}
      onKeyDown={onKeyDown}
      className={cn(
        'focus-visible:ring-icon-primary/30 flex w-full max-w-[277px] cursor-pointer flex-col items-center gap-2 rounded-2xl border border-solid p-4 shadow-[0px_1px_4px_0px_rgba(0,0,0,0.08)] transition-shadow outline-none focus-visible:ring-2 focus-visible:ring-offset-2 sm:gap-4 sm:p-6',
        selected ? 'border-button-secondary-border-default shadow-[0px_0px_0px_2px_rgba(0,174,255,0.2)]' : 'border-gray-200'
      )}
    >
      <p className='text-text-primary text-center text-lg leading-7 font-bold'>{title}</p>
      <div className='flex flex-col items-center gap-1 text-center text-sm'>
        <p className='text-text-primary text-sm leading-5 font-bold'>{featureTitle}</p>
        <p className='text-text-secondary leading-5'>{featureSub}</p>
      </div>
      <p className='text-text-secondary text-center text-sm leading-5 whitespace-pre-wrap'>{priceLine}</p>
    </div>
  )
}
